import { Link } from 'react-router-dom';

interface BreadCrumbsProps {
  children?: React.ReactNode;
  actions?: React.ReactNode;
}

export const baseCrumbClasses = [
  'bg-theme-primary',
  'text-theme-primary-contrast',
  'border-2',
  'border-theme-border',
  'font-bold',
  'text-center',
  'inline-block',
  'px-4',
  'py-2',
  'compact:px-2',
  'compact:py-1',
  'compact:text-xs',
  'cursor-pointer',
  'relative',
  'hover:bg-theme-primary-hover',
  'shadow-sm',
  'shadow-theme-shadow',
  'transition-colors',
  'last:after:content-[""]',
  'last:after:absolute',
  'last:after:top-0',
  'last:after:-right-[16px]',
  'last:after:h-full',
  'last:after:w-0',
  'last:after:border-t-[18px]',
  'last:after:border-t-transparent',
  'last:after:border-b-[19px]',
  'last:after:border-b-transparent',
  'last:after:border-l-[16px]',
  'last:after:border-l-theme-primary',
  'compact:last:after:border-b-[12px]',
  'compact:last:after:border-t-[12px]',
  'hover:last:after:border-l-theme-primary-hover',
  'last:border-r-0',
].join(' ')

export const Breadcrumbs = (props: BreadCrumbsProps) => {
  const { children, actions } = props;

  return (
    <div className="flex justify-center shrink-0">
      <div className="py-6 compact:py-2 container">
        <div className="flex items-center relative">
          <div className="flex items-center gap-0.5 flex-wrap pr-[16px]">
            <Link to="/" className={`${baseCrumbClasses} text-sm md:text-base p-2 lg:px-6`}>Home</Link>
            {children}
          </div>
          {actions && <div className="ml-auto">{actions}</div>}
        </div>
      </div>
    </div>
  );
}